import { atom } from "jotai/index";

export const scrollAtom = atom({
  scroll: false,
  activePage: undefined,
});
